exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0 !important; }\n\n.left-header {\n  margin-bottom: 16px; }\n\n.right-header {\n  margin-bottom: 16px; }\n\n.left-header Button:nth-of-type(1) {\n  background: #1890ff;\n  color: #fff; }\n\n.mr10 {\n  margin-right: 10px; }\n", ""]);

// exports
